<div *ngIf="loading">Lade...</div>
<san-stepper
  #stepperComponent
  [hideBottomButtons]="true"
  [leftButtonText]="leftButtonText"
  [rightButtonText]="rightButtonText"
  [showSteps]="false"
>
  <san-step>
    <p>{{ anrede }},</p>
    <p>ab sofort ist die Angabe Ihrer Praxis-Telefonnummer notwendig.</p>
    <p>
      Bitte tragen Sie diese hier ein, bevor Sie das Sanakey-Portal weiter
      nutzen.
    </p>
    <p>
      <san-stammdaten
        #stammdatenComponent
        (data-ready)="onDataReady()"
        (saveError)="onDataSaveError()"
        (saved)="onDataSaved()"
        [forceRequired]="this.forceRequiredKeys"
        [onlyKeys]="abzufragendeKeys"
        [speichernBtnVisible]="false" [showVerwalterAccounts]="false"
      ></san-stammdaten>
    </p>
    <p>
      <button
        (click)="speichern()"
        [disabled]="stammdatenComponent.processingAnyData"
        class="btn btn-primary"
      >
        Telefonnummer hinterlegen<span
        *ngIf="stammdatenComponent.processingAnyData"
      >
          &nbsp;<fa-icon [icon]="faSpinner" animation="spin-pulse"></fa-icon
      ></span>
      </button>
    </p>
    <p>Vielen Dank!</p>
    <div>
      Für Rückfragen stehen wir gern zur Verfügung:
      <a href="mailto:service@sanakey-portal.de"
      >service&#64;sanakey-portal.de</a
      >
    </div>
  </san-step>
  <san-step></san-step>
</san-stepper>
